import React  from "react";
import PropTypes from "prop-types";

export const Button = ({ onClick, hidden = false, disabled = false, children, type }) => <button type="button" className={`button--${type} ${hidden ? 'button--hidden': ''}`} disabled={disabled} onClick={onClick}>{children}</button>

Button.propTypes = {
  onClick: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  children: PropTypes.node.isRequired,
  type: PropTypes.string.isRequired
}
